import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=048d4129&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=048d4129&lang=less&scoped=true"
import style1 from "./dialog.vue?vue&type=style&index=1&id=048d4129&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d4129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048d4129')) {
      api.createRecord('048d4129', component.options)
    } else {
      api.reload('048d4129', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=048d4129&scoped=true", function () {
      api.rerender('048d4129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlterDialog/dialog.vue"
export default component.exports